export const TEST_SIGNUP_TAG = '+testsignup';
